export const LOADING = 'LOADING';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';

export const STATUS_FAILED = 'failed';
export const STATUS_SUCCESS = 'success';
export const STATUS_NEUTRAL = 'neutral';
export const STATUS_NOT_FOUND = 'not_found';

export const status = {
  LOADING,
  ERROR,
  SUCCESS,
};

/**
 * Slot names for the ReportSection component, corresponding to the success,
 * loading and error statuses.
 */
export const SLOT_SUCCESS = 'success';
export const SLOT_LOADING = 'loading';
export const SLOT_ERROR = 'error';

export const CODE_QUALITY_SCALE_KEY = 'codeQuality';
export const SAST_SCALE_KEY = 'sast';
